import {NewsBookmarksError} from './NewsBookmarksError.js'

export class SaveNewsBookmarksError extends NewsBookmarksError {
  constructor(message) {
    super(message)
    this.name = 'SaveNewsBookmarksError'
  }

  static create(message) {
    return new SaveNewsBookmarksError(message)
  }
}
